import { useSessionStore } from '@/entities/session';
import { useAppSettingsStore } from '@/shared/lib';
import type { Language } from '@/shared/types';
import {
  toPreferredLanguage,
  useUpdateUserProfileSettings,
} from '../api/mutations';

export function useChangePreferredLanguage() {
  const { updateSettingsAsync, isPending, error } =
    useUpdateUserProfileSettings();

  const changeLanguage = async (language: Language) => {
    if (language === useAppSettingsStore.getState().getLanguage()) {
      return;
    }

    const preferredLanguage = toPreferredLanguage(language);

    await updateSettingsAsync({ preferredLanguage });

    useAppSettingsStore.getState().setLanguage(language);

    const { session, setSession } = useSessionStore.getState();

    if (session?.additional) {
      setSession({
        ...session,
        additional: { ...session.additional, preferredLanguage },
      });
    }
  };

  return { changeLanguage, isPending, error };
}
